var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3464 7.3335V14.0002H2.67969V7.3335",
    stroke: "#333333",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.94693 4.5922C1.43708 5.91257 2.42052 7.33333 3.8359 7.33333C4.94046 7.33333 5.84203 6.4379 5.84203 5.33333C5.84203 6.4379 6.73746 7.33333 7.84203 7.33333H8.1815C9.28606 7.33333 10.1815 6.4379 10.1815 5.33333C10.1815 6.4379 11.0834 7.33333 12.188 7.33333C13.6041 7.33333 14.5885 5.91173 14.0782 4.59077L13.0774 2H2.94791L1.94693 4.5922Z",
    stroke: "#333333",
    strokeWidth: 1.33333,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default "https://c.d2cgo.com/dtc_center-setting/v19/assets/static/media/shop.b6372badddb4fd80aafb32a5b252cd71.svg";
export { ForwardRef as ReactComponent };